import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {scrolledToMultimedia} from 'shared/portfolio/actions/multimedia';
import {MONTH_ABBRVS} from 'shared/utils';
import RotatableMediaCard from './rotatable-media-card';

interface Props {
  _id: string;
  title: string;
  category: string;
  previewUrls?: string[];
  scrollTo?: boolean;
  year: string | number;
  month: string | number;
}

const Multimedia = ({
  title,
  category,
  year,
  month,
  previewUrls = [],
  scrollTo = false,
  _id,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToMultimedia(_id));
      }, 550);
    }
  }, [_id, dispatch, scrollTo]);

  return (
    <div className="multimedia-container" ref={ref}>
      <div className="portfolio-sections card-header">
        <RotatableMediaCard previewUrls={previewUrls} />
        <div className="media-card-title media-card-text">{title}</div>
        <div className="media-card-category media-card-text">{category}</div>
        <div className="media-card-date media-card-text">
          {MONTH_ABBRVS[month]} {year}
        </div>
      </div>
    </div>
  );
};

export default Multimedia;
